export default "__VITE_ASSET__Bpl9Mdk0__"